type Options = {
  target?: string
  behavior: ScrollBehavior
}

export function scrollToFirstError(options: Options) {
  const { target = '', behavior } = options

  const firstError = document.querySelector(
    `${target} [data-tone="critical"]:not(:empty)`
  )

  if (firstError) {
    firstError.scrollIntoView({ block: 'end', behavior })
  }
}
